import LoadingCard from '@components/LoadingCard';
import BootstrapVue from 'bootstrap-vue';
import VeeValidate from 'vee-validate';
import Vue from 'vue';
import VueAutosize from 'vue-autosize';
import Cleave from 'vue-cleave-component';
import VueCropper from 'vue-cropperjs';
import FlatPickr from 'vue-flatpickr-component';
import VueHeadful from 'vue-headful';
import VueMultiSelect from 'vue-multiselect/dist/vue-multiselect.min.js';
import * as VueGoogleMaps from 'vue2-google-maps';
import Vuebar from 'vuebar';

Vue.use(VueAutosize);
Vue.use(BootstrapVue);
Vue.use(Vuebar);
Vue.use(VeeValidate, {
  fieldsBagName: 'formFields',
  classes: true,
  validity: false,
  classNames: {
    // touched: 'touched', // the control has been blurred
    // untouched: 'untouched', // the control hasn't been blurred
    // valid: 'is-valid', // model is valid
    invalid: 'is-invalid', // model is not valid
    // pristine: 'pristine', // control has not been interacted with
    // dirty: 'dirty' // control has been interacted with
  },
});
Vue.use(VueGoogleMaps, {
  load: {
    key: window.config.googleMapKey,
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  },
});

Vue.component('VueMetaManager', VueHeadful);
Vue.component('VueCropper', VueCropper);
Vue.component('VueSelect', VueMultiSelect);
Vue.component('VueDatePicker', FlatPickr);
Vue.component('VueMask', Cleave);
Vue.component('LoadingCard', LoadingCard);
